module.exports = __webpack_public_path__ + "static/media/short-arrow-r-green.56dafb0a.svg";